export const ADMIN_BALANCES_EDIT_ROUTE_NAME = Symbol('admin.balances.edit');

export const BALANCES_ITEM_URL = 'admin/affiliate_cashouts/balance/:id';
export const BALANCES_ITEM_QUERY_KEY = 'balances.item';

export const BALANCES_EDIT_URL = 'admin/affiliate_cashouts/balance/update_balance';
export const BALANCES_EDIT_MUTATION_KEY = 'balances.edit';
